export default __webpack_public_path__ + "static/media/WEX-USDT.569eba18.png";